<ng-container [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label i18n>Relation</mat-label>
    <mat-select id="relation" formControlName="relation">
      @for (option of relationNamesWithCategoryNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>{{ getRelationName() }}</mat-label>
    <mat-select id="relation-category" multiple formControlName="relationCategories">
      @for (option of getRelationCategories(); track option) {
        <mat-option [value]="option.id" [title]="option.name">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</ng-container>
